import { useTranslation } from "react-i18next";
import { FinancialAnalyticsChart } from "./FinancialAnalyticsChart";
import { OrderAnalyticsChart } from "./OrderAnalyticsChart";
import { DashboardStatsCards } from "./DashboardStatsCards";
import { WeeklyRevenueChart } from "./WeeklyRevenueChart";
import { RecentOrdersList } from "./RecentOrdersList";
import { useDashboardData } from "../../hooks/useDashboardData";
import { useStoreManagementStore } from "@/store/storeManagement";
import { formatCurrency } from "@/lib/currencyFormatter";

export interface DashboardOverviewProps {
  storeId: string;
}

export function DashboardOverviewComponent({
  storeId,
}: DashboardOverviewProps) {
  const { t } = useTranslation();
  const {
    weeklyRevenueData,
    stats,
    recentOrders,
    monthlyRevenueData,
    orderAnalyticsData,
    isLoading,
  } = useDashboardData(storeId);
  const { selectedStoreId } = useStoreManagementStore();
  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <DashboardStatsCards stats={stats} isLoading={isLoading} />

      <div className="grid gap-6 md:grid-cols-3">
        {/* Weekly Revenue Chart */}
        <WeeklyRevenueChart data={weeklyRevenueData} isLoading={isLoading} />

        {/* Recent Orders */}
        <RecentOrdersList orders={recentOrders} isLoading={isLoading} />
      </div>

      {/* Financial and Order Analytics Charts */}
      <div className="grid gap-6 md:grid-cols-1">
        <FinancialAnalyticsChart
          storeId={selectedStoreId}
          data={monthlyRevenueData}
        />
        <OrderAnalyticsChart
          storeId={selectedStoreId}
          data={orderAnalyticsData}
        />
      </div>
    </div>
  );
}

export default DashboardOverviewComponent;
